module.exports = JSON.parse("{\"timestamp\":\"22.10.2026 - 16:02:20\",\"brands\":[]}")